var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotOutcomeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 60,
    viewBox: "0 0 75 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M56 19C56 29.4934 47.4934 38 37 38C26.5066 38 18 29.4934 18 19C18 8.50659 26.5066 0 37 0C47.4934 0 56 8.50659 56 19Z",
    fill: "#ffffff",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 59.5C58 59.5 57.9345 59.5 37.5 59.5C16 59.5 16.5 59.5 0 59.5C0 52.8726 17.0655 42 37.5 42C57.9345 42 74.5 52.8726 74.5 59.5Z",
    fill: "#ffffff",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotOutcomeIcon);
export default __webpack_public_path__ + "static/media/hot-outcome-icon.cfb407e173225c51b48462f1e9789e8a.svg";
export { ForwardRef as ReactComponent };